import React, {
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from "react";
import { SimpleDialog } from "simple-ui-components";

import { AlertMessage } from "../../theme";
import { getTranslation } from "../languageProvider";

export const ShowPassword = forwardRef((props, ref) => {
  const { Dialog, DialogBody } = SimpleDialog;

  const [open, setOpen] = useState(false);
  const [accountInfo, setAccountInfo] = useState({});
  const handleClose = useCallback(() => setOpen(false), []);
  // trigger from props
  useImperativeHandle(ref, () => ({
    ShowPassword(info) {
      setOpen(true);
      setAccountInfo(info);
    },
  }));
  return (
    <>
      {open && (
        <Dialog
          theme="default"
          size="sm"
          close={handleClose}
          open={open}
          title={getTranslation("0049")}
        >
          <DialogBody>
            <AlertMessage>
              <span>{accountInfo.success}</span>
              <b data-translate="0131">{getTranslation("0131")}</b>
              <div>
                <span data-translate="0050">{getTranslation("0050")}:</span>{" "}
                {accountInfo.name}
              </div>
              <div>
                <span data-translate="0002">{getTranslation("0002")}:</span>{" "}
                {accountInfo.email}
              </div>
              <div>
                <span data-translate="0003">{getTranslation("0003")}:</span>{" "}
                {accountInfo.password}
              </div>
            </AlertMessage>
          </DialogBody>
        </Dialog>
      )}
    </>
  );
});
